var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[`protokol-ekosistem-2`, _vm.className || ``]},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"protokol-ekosistem"},[_c('div',{staticClass:"overlap-group-12"},[_c('div',{staticClass:"reach-goals-that-mat inter-medium-chetwode-blue-12px"},[_vm._v("protokol ekosistem")])])])
}]

export { render, staticRenderFns }